(function (w) {
    var Search = {
        $input: null,
        $container: null,
        $submit: null,
        $loader: null,
        $results: null,
        action: null,
        timeoutId: null,
        ajaxSearchProcess: null,
        currentQuery: '',
        initialQuery: '',
        maxQueryLength: 100,
        options: {
            hideQuery: false
        },
        searchTimerId : null,
        init: function (selector, options) {
            this.$input = $(selector);
            this.$container = this.$input.parents('.j-search');
            this.$submit = this.$input.siblings('button[type="submit"]');
            this.$loader = $('<div class="loader-spinner loader-spinner--form" style="display: none" />').appendTo(this.$submit);
            this.$results = $('<div class="search-results" style="display: none" />').insertAfter(this.$input);
            this.action = this.$input.parents('form:first').attr('data-action');
            this.initialQuery = this.$input.val();
            this.options = $.extend(this.options, options);

            this.bindEvents();
            this.bindSubmitEvent(selector);
        },
        bindEvents: function () {
            var self = this;

            this.$input
                .on('input', function () {
                    if(Number.isInteger(this.searchTimerId)) {
                        clearTimeout(this.searchTimerId);
                    }

                    if (Search.$input.val().length > Search.maxQueryLength) {
                        Search.$input.val(Search.$input.val().substring(0, Search.maxQueryLength))
                    }

                    this.searchTimerId = setTimeout($.proxy(Search.search, Search), 300);
                })
                .on('focus', function (e) {
                    if (self.options.hideQuery) {
                        self.showQuery(e);
                    }
                });

            $(document.body).on('mousedown', function (e) {
                if (self.options.hideQuery) {
                    self.hideQuery(e);
                }
                self.hideResults(e);
            });
        },
        bindSubmitEvent: function (selector) {
            const form = $(selector).parents('form:first').get(0)
            $(form).on('submit', function () {
                $(form).attr('action', $(form).data('action'))
            });
        },
        search: function() {
            this.checkResults();
            this.updateSubmitButton();
        },
        checkResults: function () {
            clearTimeout(this.timeoutId);
            if (this.$input.val() === '') {
                if (this.ajaxSearchProcess) {
                    this.ajaxSearchProcess.abort();
                }

                this.$results.hide();
                this.$loader.hide();
                this.$submit.find('.icon--search').show();
                return;
            }

            if (this.currentQuery === this.$input.val()) {
                return;
            }

            this.currentQuery = this.$input.val();
            this.timeoutId = setTimeout(this.load.bind(this), 550);

        },
        updateSubmitButton: function () {
            if (this.$input.val() !== '') {
                this.$submit.prop('disabled', false);
            } else {
                this.$submit.prop('disabled', true);
            }
        },
        load: function () {
            this.$loader.fadeIn(150);
            this.$submit.find('.icon--search').hide();
            if (this.ajaxSearchProcess) {
                this.ajaxSearchProcess.abort();
            }
            this.ajaxSearchProcess = w.sendAjax(
                this.action,
                {
                    q: this.currentQuery,
                    quick_search: 1
                },
                this.loadCallback.bind(this)
            );
        },
        loadCallback: function (status, response) {
            var self = this;
            var isWidgetCollapsed = this.$container.attr('data-collapsed') === 'true';
                if (status === 'OK' && !isWidgetCollapsed) {
                    this.$loader.fadeOut(150, function () {
                        self.$submit.find('.icon--search').show();
                    });
                    this.$results.html(response.html).show();
                } else if (status !== 'CANCELED') {
                    this.$loader.fadeOut(150, function () {
                        self.$submit.find('.icon--search').show();
                    });
                    this.$results.hide();
                }
            this.ajaxSearchProcess = null;

            w.triggerMarketingEvent('quick_search', [{'term': this.currentQuery}, response.eventId]);
        },
        hideResults: function (e) {
            var target = $(e.target);

            if (
                !target.is(this.$input) &&
                !target.is(this.$results) &&
                !target.is(this.$results.find('*'))
            ) {
                this.$loader.hide();
                this.$submit.find('.icon--search').show();
                this.$results.hide();
                clearTimeout(this.timeoutId);
            }
        },
        showQuery: function (e) {
            if (
                $(e.currentTarget).closest('input').length &&
                !$(e.target).is(this.$submit)
            ) {
                this.$container.addClass('is-focused');

                if (this.currentQuery !== '') {
                    this.$input.val(this.currentQuery);
                    this.updateSubmitButton();
                }
            }
        },
        hideQuery: function (e) {
            var $target = $(e.target);

            if (
                this.$container.find($target).length === 0
            ) {
                this.$container.removeClass('is-focused');

                if (this.initialQuery === '') {
                    this.$input.val('');
                    this.updateSubmitButton();
                }
            }
        }
    };

    function init_search_widget(selector, options) {
        Search.init(selector, options);
    }

    function init_search_submit(selector, options) {
        Search.bindSubmitEvent(selector);
    }

    w.Search = Search;
    w.init_search_widget = init_search_widget;
    w.init_search_submit = init_search_submit;
})(window);
